/**
 * App bar brand lockups, per product.
 *
 * Keyed by app mode, so adding a variant's artwork is a one-line change here —
 * BrandLogo falls back to a text lockup for any mode with no entry.
 *
 * The SVGs are full lockups (AMD wordmark + the EPYC <product> badge) and carry
 * their own black/white fills, so they are rendered as <img> rather than inline:
 * nothing recolours them, and they stay out of the JS bundle's parse cost.
 *
 * Both lockups are the same size — 611x307 (the 2026-10-29 artwork; the old
 * ones were 90x46 and 88x45) — so any consumer that sizes by HEIGHT gets
 * matching optical weight across variants for free.
 *
 * Used by the app bar and by the sign-in page, which is why this map is the one
 * place a variant's artwork is registered.
 */
import ccaLogo from '@/assets/appBarLogo/CCA.svg';
import eiaLogo from '@/assets/appBarLogo/EIA.svg';

export const APP_BAR_LOGOS = Object.freeze({
  cca: ccaLogo,
  eia: eiaLogo,
});
